var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "13.375px",
    height: "16.458px",
    viewBox: "0 0 13.375 16.458",
    enableBackground: "new 0 0 13.375 16.458",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M0.417,6.369v1.88c0,1.932,2.88,3.167,6.333,3.167s6.334-1.234,6.334-3.167v-1.88 c-1.437,1.18-3.676,1.88-6.334,1.88S1.853,7.549,0.417,6.369z M0.417,11.119V13c0,1.932,2.88,3.166,6.333,3.166 s6.334-1.234,6.334-3.166v-1.881C11.647,12.299,9.408,13,6.75,13S1.853,12.299,0.417,11.119z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M6.75,0.333c-3.453,0-6.333,1.234-6.333,3.167s2.88,3.167,6.333,3.167s6.334-1.234,6.334-3.167 S10.203,0.333,6.75,0.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositProfile);
export default __webpack_public_path__ + "static/media/depositProfile.66758cccb97157cf38dbfef1be9a6468.svg";
export { ForwardRef as ReactComponent };